<template>

  <div class="container">
    <div class="container flexVC pR" v-if="$store.state.isPc">
      <div style="height: 100px;"></div>
      <div style="width: 320px;height: 90px;" class="pR flexVC">
        <div class="title">趁早的使命</div>
        <div class="w100 pR title-line-box">
          <div class="titleLine"></div>
          <div class="titleLine-animation"
               :class="currentIndex == 2 ? 'titleLine-animation-index' : '' "></div>
        </div>
      </div>
      <div class="content">
        <div>趁早，创建正向生活</div>
        <div>通过线上线下内容，配套创新型文创产品以及线上陪伴式目标达成工具「趁早行动」、支持使用者养成习惯，抵达目标</div>
      </div>
      <!--    <img src="../../../assets/images/icon_home_second.png" class="w100"/>-->
      <el-image
        class="bottom"
        :src="homeSecondImg"
        :fit="cover"></el-image>
      <!--    <div class="bottom"></div>-->
    </div>
    <div class="container-m pR flexVC" v-if="!$store.state.isPc">
      <div style="height: 13.9%;"></div>
      <div style="width: 2.3rem;height: 0.6rem;" class="pR flexVC">
        <div class="title-m">趁早的使命</div>
        <div class="w100 pR title-line-box-m">
          <div class="titleLine-m"></div>
          <div class="titleLine-animation-m"
               :class="currentIndex == 2 ? 'titleLine-animation-index-m' : '' "></div>
        </div>
      </div>
      <div class="content-m" style="margin-top: 0.5rem;">趁早，创建正向生活</div>
      <div class="content-m">通过线上线下内容配套创新型文创产品</div>
      <div class="content-m">以及线上陪伴式目标达成工具「趁早行动」</div>
      <div class="content-m">支持使用者养成习惯，抵达目标</div>

      <el-image
        class="bottom-m"
        :src="homeSecondImgM"
        :fit="cover"></el-image>
    </div>
  </div>

</template>

<script>
  import homeSecondImg from '@/assets/images/icon_home_second.png'

  export default {
    name: "HomeSecond",
    props: ['currentIndex'],
    data () {
      return {
        cover: 'cover',
        homeSecondImg: homeSecondImg,
        homeSecondImgM: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mobile/icon_home_2.png',
      }
    },

  }
</script>

<style scoped>

  .title {
    width: 100%;
    font-size: 60px;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: bolder;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    text-align: center;
    left: 0;
    top: 0;
    z-index: 10;
  }

  .title-line-box {
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine {
    width: 100%;
    height: 26px;
    background: #FFCCC0;
  }

  .titleLine-animation {
    width: 100%;
    height: 26px;
    background: #FFFFFF;
    position: absolute;
    top: 0;
    left: 0;
  }

  .content {
    width: 100%;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 30px;
    text-align: center;
    margin-top: 80px;
    z-index: 100;
  }

  .bottom {
    width: 100%;
    height: 55.56%;
    position: absolute;
    left: 0;
    bottom: 0;
    background-image: url("../../../assets/images/icon_home_second.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .titleLine-animation-index {
    -webkit-animation: spin 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spin 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }

  /*定义动画*/
  @-webkit-keyframes spin { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0px);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(310px);
    }
  }

  @keyframes spin {
    from {
      transform: translateX(0px);
    }
    to {
      transform: translateX(310px);
    }
  }

  @media screen and (max-width: 1440px){
    .bottom {
      width: 100%;
      height: 40.56%;
      position: absolute;
      left: 0;
      bottom: 0;
      background-image: url("../../../assets/images/icon_home_second.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }


  /**********************************  移动端********************************************/

  .bottom-m {
    width: 100%;
    height: 52.47%;
    position: absolute;
    left: 0;
    bottom: 0;
    background-image: url("https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/mobile/icon_home_2.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .content-m{
    font-size: 0.26rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 0.44rem;
  }

  .title-m {
    width: 100%;
    font-size: 0.4rem;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: bolder;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    text-align: center;
    left: 0;
    top: 0;
    z-index: 10;
  }

  .title-line-box-m {
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine-m {
    width: 100%;
    height: 0.16rem;
    background: #FFCCC0;
  }

  .titleLine-animation-m {
    width: 100%;
    height: 0.16rem;
    background: #f0f2f5;
    position: absolute;
    top: 0;
    left: 0;
  }

  .titleLine-animation-index-m {
    -webkit-animation: spinm 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spinm 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }

  /*定义动画*/
  @-webkit-keyframes spinm { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0%);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(100%);
    }
  }

  @keyframes spinm {
    from {
      -webkit-transform: translateX(0%);
    }
    to {
      -webkit-transform: translateX(100%);
    }
  }


  /*  *************************************************************************************/

</style>



// WEBPACK FOOTER //
// src/page/home/components/HomeSecond.vue